import React from "react";
import {  ALL_POD_NAMES } from "../ResilienceConstants";
import "./SourceToDestinationAccountTable.scss";
   

export const SourceToDestinationAccountTable = ({rows, region}) => {

    const getCellKeys = region ? ALL_POD_NAMES[region] : '';
    const getKeysForAccounts = (region, rows) => {
        switch (region) {
            case 'NA':
                return rows.map((r) =>
                        <tr key={r.sourceAccount}>
                        <td>{r.sourceAccount}</td>
                        <td>{r.IADCell1}</td>
                        </tr>                    
                )
                break;
            }
    }

    return (
        <>
        { region ? <table className="resourcePropertiesTable">
            <tbody>
                <tr>
                    <th></th>
                    <th colSpan={getCellKeys.length}>Destination Account Name</th>
                </tr>
                <tr>
                    <th>Source Account</th>
                    {
                        getCellKeys.map((r) =>
                        <th key={r}>{r}</th>
                    )}
                </tr>
                {getKeysForAccounts(region, rows)}
            </tbody>
        </table> : null}
        </>
    )
}